import { render, staticRenderFns } from "./ArmInfo.vue?vue&type=template&id=b7f73ed0"
import script from "./ArmInfo.vue?vue&type=script&lang=js"
export * from "./ArmInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports